export default "__VITE_ASSET__DHpzzu4i__"